// extracted by mini-css-extract-plugin
module.exports = {"image-container":"propertyGalleryCard_image-container__21jhg","imageContainer":"propertyGalleryCard_image-container__21jhg","image":"propertyGalleryCard_image__1CZTi","image1":"propertyGalleryCard_image1__2twjy","image2":"propertyGalleryCard_image2__39ocX","imageMap":"propertyGalleryCard_imageMap__3ZSiU"};
    if(module.hot) {
      // 1790670288431
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  